document.addEventListener('DOMContentLoaded', () => {
  const benefitBlocks = document.querySelectorAll<HTMLElement>('.benefit');

  benefitBlocks.forEach((benefit) => {
    const video = benefit.querySelector<HTMLVideoElement>('video');
    if (!video) return;

    // Play video on hover
    benefit.addEventListener('mouseenter', () => {
      pauseAllVideosExcept(video);
      video.play().catch((err) => console.warn('Play failed:', err));
    });

    // Pause and reset (with delay to prevent iOS poster flicker)
    benefit.addEventListener('mouseleave', () => {
      video.pause();
      setTimeout(() => {
        video.currentTime = 0;
      }, 100); // small delay prevents blink
    });

    // Play on click
    benefit.addEventListener('click', () => {
      pauseAllVideosExcept(video);
      video.play().catch((err) => console.warn('Play failed:', err));
    });
  });

  // Pause other videos without resetting (preserves posters)
  function pauseAllVideosExcept(currentVideo: HTMLVideoElement): void {
    const allVideos = document.querySelectorAll<HTMLVideoElement>('.benefit video');
    allVideos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
        // No currentTime reset here
      }
    });
  }
});

// transaprency  video about us page
document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.getElementById('video-play');
  const video = targetElement?.querySelector('video');

  if (!targetElement || !video) {
    console.warn('Video or target element not found');
    return;
  }

  window.addEventListener('scroll', () => {
    const scrollOffset = 200;
    const rect = targetElement.getBoundingClientRect();
    const isCompletelyOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;

    // Case 1: Scroll down at least 200px and video is in view
    if (window.scrollY >= scrollOffset && !isCompletelyOutOfView) {
      if (!targetElement.classList.contains('wide-video')) {
        targetElement.classList.add('wide-video');
        video.play().catch(err => console.warn('Video play failed:', err));
      }
    }

    // Case 2: Scroll back up or leave the section entirely
    if (window.scrollY < scrollOffset || isCompletelyOutOfView) {
      if (targetElement.classList.contains('wide-video')) {
        targetElement.classList.remove('wide-video');
        video.pause();
        video.currentTime = 0;
      }
    }
  });
});

// steps video
document.addEventListener('DOMContentLoaded', () => {
  const steps = document.querySelectorAll<HTMLElement>('.step');

  steps.forEach((step) => {
    const video = step.querySelector<HTMLVideoElement>('video');
    if (!video) return;

    // Play on hover
    step.addEventListener('mouseenter', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Play failed:', err));
    });

    // Pause and delayed reset on leave (prevents flicker)
    step.addEventListener('mouseleave', () => {
      video.pause();
      setTimeout(() => {
        video.currentTime = 0;
      }, 100); // small delay avoids iOS poster flicker
    });

    // Play on click
    step.addEventListener('click', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Play failed:', err));
    });
  });

  function pauseAllVideosExcept(currentVideo: HTMLVideoElement): void {
    const allVideos = document.querySelectorAll<HTMLVideoElement>('.step__video video');
    allVideos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
        // ⚠️ Do NOT reset currentTime here — it breaks posters on iOS
      }
    });
  }
});


// new vide
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll<HTMLElement>('.step, .item');

  containers.forEach((container) => {
    const video = container.querySelector<HTMLVideoElement>('video');
    if (!video) return;

    // Play on hover
    container.addEventListener('mouseenter', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Video play failed:', err));
    });

    // Pause and reset with slight delay to prevent iOS flicker
    container.addEventListener('mouseleave', () => {
      video.pause();
      setTimeout(() => {
        video.currentTime = 0;
      }, 100); // Delay allows poster to reload without flicker
    });

    // Play on click
    container.addEventListener('click', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Video play failed:', err));
    });
  });

  function pauseAllVideosExcept(currentVideo: HTMLVideoElement): void {
    const allVideos = document.querySelectorAll<HTMLVideoElement>('.step video, .item__video video');
    allVideos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
        // ❌ Do not reset currentTime here — avoids iOS poster loss
      }
    });
  }
});


// homepage video
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll<HTMLElement>('.step, .item');
  const contentTrigger = document.getElementById('content-2');
  const videoInContent = contentTrigger?.querySelector<HTMLVideoElement>('video');

  // Hover and click logic
  containers.forEach((container) => {
    const video = container.querySelector<HTMLVideoElement>('video');
    if (!video) return;

    container.addEventListener('mouseenter', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Video play failed:', err));
    });

    container.addEventListener('mouseleave', () => {
      video.pause();
      setTimeout(() => {
        video.currentTime = 0; // Delay prevents iOS flicker
      }, 100);
    });

    container.addEventListener('click', () => {
      pauseAllVideosExcept(video);
      video.play().catch(err => console.warn('Video play failed:', err));
    });
  });

  function pauseAllVideosExcept(currentVideo: HTMLVideoElement): void {
    const allVideos = document.querySelectorAll<HTMLVideoElement>('.step video, .item__video video');
    allVideos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
        // Don't reset currentTime here to avoid poster flickering on iOS
      }
    });
  }

  // Scroll-based autoplay for #content-2
  if (contentTrigger && videoInContent) {
    window.addEventListener('scroll', () => {
      const rect = contentTrigger.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (isVisible) {
        if (videoInContent.paused) {
          pauseAllVideosExcept(videoInContent);
          videoInContent.play().catch(err => console.warn('Scroll video play failed:', err));
        }
      } else {
        videoInContent.pause();
        setTimeout(() => {
          videoInContent.currentTime = 0; // Delayed reset avoids poster loss
        }, 100);
      }
    });
  }
});
